import * as React from "react";

const InfoNew: React.FC = () => {
    return (
        <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="#002554" fill-rule="nonzero"><path d="M12.227 15.5V8.75h-3v1.5h1.5v5.25h-2.25V17h6v-1.5h-2.25Zm-.75-11.25a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"/><path d="M11.477 21.5c-5.8 0-10.5-4.701-10.5-10.5S5.677.5 11.477.5c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5Zm0-19.5a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"/></g></svg>
    );
};

export default React.memo(InfoNew);
